import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters";

import vSelect from "vue-select";
import VueTheMask from "vue-the-mask";

require("vue2-daterange-picker/src/assets/daterangepicker.css");

router.beforeEach((to, from, next) => {
  if (!store.state.isAuthorized) {
    store.dispatch("getUser").then((res) => {
      if (res.status === 401) {
        // console.log(res.status);
        next();
      } else {
        if (res.role === 4) {
          store.dispatch("getUserAwards").then((res) => {
            if (res.status === 401) {
              console.log(res.status);
            }
            next();
          });
        } else {
          next();
        }
      }
    });
  } else {
    next();
  }
});

Vue.component("v-select", vSelect);
Vue.use(VueTheMask);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
